import { EGetNotificationsListActionTypes, TGetNotificationsListSucceed } from './types';
import { TNotification } from '../../../types/notifications';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const getNotificationsListSucceed: (notifications: TNotification[]) => TGetNotificationsListSucceed =
  actionGenerator<EGetNotificationsListActionTypes.Succeed, TNotification[]>(EGetNotificationsListActionTypes.Succeed);
